import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-check",
  "use": "n-icon-check-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"n-icon-check\">\n    <path d=\"M8.00003 12.7003L4.64021 9.23376C4.21593 8.88019 3.58537 8.93752 3.2318 9.36179C2.87824 9.78607 2.93556 10.4166 3.35984 10.7702L7.35984 14.7702C7.73069 15.0792 8.26936 15.0792 8.64021 14.7702L16.6402 6.7702C17.0645 6.41663 17.1218 5.78607 16.7682 5.36179C16.4147 4.93752 15.7841 4.88019 15.3598 5.23376L8.00003 12.7003Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol